module.exports = __webpack_public_path__ + "img/ic-success-register-program.23c1efdc.svg";